export default __webpack_public_path__ + "static/media/stadium.ace4ff75.jpg";